// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PROGRESS_STATUSES } from 'symbols';
import { EnterpriseService } from '../../services/enterprise.service';
import { GetEnterpriseList } from './enterprise.actions';
import { ENTERPRISE_STATE_DEFAULT, EnterpriseStateModel } from './enterprise.model';

@State({ name: 'Enterprise', defaults: ENTERPRISE_STATE_DEFAULT })
@Injectable()
export class EnterpriseState {

  constructor(private enterpriseService: EnterpriseService) {
  }

  @Selector()
  static enterpriseList(state: EnterpriseStateModel): EnterpriseStateModel['enterpriseList'] {
    return state.enterpriseList;
  }


  @Selector()
  static loadEnterpriseListStatus(state: EnterpriseStateModel): EnterpriseStateModel['loadEnterpriseListStatus'] {
    return state.loadEnterpriseListStatus;
  }

  @Action(GetEnterpriseList)
  setExampleField(ctx: StateContext<EnterpriseStateModel>): void {
    ctx.patchState({
      loadEnterpriseListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.enterpriseService.getEnterpriseList()
      .subscribe({
        next: res => ctx.patchState({
          loadEnterpriseListStatus: PROGRESS_STATUSES.SUCCESS,
          enterpriseList: res
        }),
        error: error => ctx.patchState({
          loadEnterpriseListStatus: PROGRESS_STATUSES.FAIL
        })
      });

  }
}


